import React from 'react';
import styled from 'styled-components';
import { Flex } from '@decisiv/ui-components';
import { H1 } from '@decisiv/ui-components/lib/components/Typography';
import KeyDSPageContainer from 'components/KeyDSPageContainer';

// Simple breadcrumb nav — avoids KDS Breadcrumbs component API complexity.
const BreadcrumbNav = styled.nav`
  font-size: 13px;
  margin-bottom: 8px;
  color: #666;

  a {
    color: #1a73c8;
    text-decoration: none;
    &:hover { text-decoration: underline; }
  }

  span.sep { margin: 0 6px; }
`;

/**
 * Consistent shell for every admin page: breadcrumbs, heading, optional
 * primary action buttons, and the page body.
 *
 * @param {string}    title
 * @param {Array}     breadcrumbs  [{ text, href? }]  last item is the current page (no href)
 * @param {ReactNode} actions      Buttons rendered at the top-right
 * @param {ReactNode} children
 */
const AdminPage = ({ title, breadcrumbs = [], actions, children }) => (
  <KeyDSPageContainer maxWidth={1400}>
    {breadcrumbs.length > 1 && (
      <BreadcrumbNav aria-label="breadcrumb">
        {breadcrumbs.map((crumb, i) => {
          const isLast = i === breadcrumbs.length - 1;
          return (
            <React.Fragment key={crumb.text}>
              {i > 0 && <span className="sep" aria-hidden="true">›</span>}
              {isLast || !crumb.href
                ? <span>{crumb.text}</span>
                : <a href={crumb.href}>{crumb.text}</a>}
            </React.Fragment>
          );
        })}
      </BreadcrumbNav>
    )}

    <Flex alignItems="center" justifyContent="space-between" marginBottom={2}>
      <H1 style={{ margin: 0 }}>{title}</H1>
      {actions && <Flex gap={1}>{actions}</Flex>}
    </Flex>

    {children}
  </KeyDSPageContainer>
);

export default AdminPage;
